/** Geometry helpers for selection/group bounds. */

/** Axis-aligned bounds of an element, accounting for rotation. */
export function elementBounds(el) {
    const rot = ((el.rotation || 0) * Math.PI) / 180;
    if (!rot) {
        return { minX: el.x, minY: el.y, maxX: el.x + el.width, maxY: el.y + el.height };
    }
    const cx = el.x + el.width / 2;
    const cy = el.y + el.height / 2;
    const pts = [
        [el.x, el.y],
        [el.x + el.width, el.y],
        [el.x, el.y + el.height],
        [el.x + el.width, el.y + el.height],
    ];
    let minX = Infinity;
    let minY = Infinity;
    let maxX = -Infinity;
    let maxY = -Infinity;
    const cos = Math.cos(rot);
    const sin = Math.sin(rot);
    pts.forEach(([pxp, pyp]) => {
        const dx = pxp - cx;
        const dy = pyp - cy;
        const rx = cx + dx * cos - dy * sin;
        const ry = cy + dx * sin + dy * cos;
        minX = Math.min(minX, rx);
        minY = Math.min(minY, ry);
        maxX = Math.max(maxX, rx);
        maxY = Math.max(maxY, ry);
    });
    return { minX, minY, maxX, maxY };
}

/** Combined axis-aligned bounds of several elements. */
export function combinedBounds(elements = []) {
    if (!elements.length) return null;
    let minX = Infinity;
    let minY = Infinity;
    let maxX = -Infinity;
    let maxY = -Infinity;
    elements.forEach((el) => {
        const b = elementBounds(el);
        minX = Math.min(minX, b.minX);
        minY = Math.min(minY, b.minY);
        maxX = Math.max(maxX, b.maxX);
        maxY = Math.max(maxY, b.maxY);
    });
    return { x: minX, y: minY, width: maxX - minX, height: maxY - minY };
}
